import { render, staticRenderFns } from "./PopupPreviewModal.vue?vue&type=template&id=242e132a&scoped=true"
import script from "./PopupPreviewModal.vue?vue&type=script&lang=js"
export * from "./PopupPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PopupPreviewModal.vue?vue&type=style&index=0&id=242e132a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e132a",
  null
  
)

export default component.exports